import { createReducer, on } from '@ngrx/store';
import {
  ParameterData,
  ParametersDataResponseRequest,
} from 'src/app/pages/admin-manager/parameters/models/parameters.model';
import {
  loadParameterDetails,
  loadParametersFailure,
  loadParametersSuccess,
  refreshLoadParametersSuccess,
  removeRequestedDisabledParameters,
  removeRequestedParameters,
  saveRequestedParameters,
} from './parameter-by-detail.actions';

export interface ParametersState {
  requested: ParametersDataResponseRequest[];
  response: ParameterData[];
  // type any because error interface is not defined in the provided code
  // and it can be any type of error (string, object, etc.)
  error: any;
  isLoading: boolean;
}

export const initialState: ParametersState = {
  requested: [],
  response: [],
  error: null,
  isLoading: false,
};

export const parameterDetailReducer = createReducer(
  initialState,
  on(saveRequestedParameters, (state, { request }) => ({
    ...state,
    requested: [...state.requested, ...request],
  })),
  on(removeRequestedParameters, (state, { request }) => ({
    ...state,
    requested: state.requested.filter(
      (req) =>
        !request.some(
          (r) =>
            r.parameterCode === req.parameterCode &&
            r.parameterScopeTypeId === req.parameterScopeTypeId &&
            r.scopeId === req.scopeId,
        ),
    ),
  })),
  on(removeRequestedDisabledParameters, (state, { request }) => ({
    ...state,
    requested: state.requested.filter((req) => req.parameterCode !== 'DISABLE_DISPATCH_ALERTS'),
  })),
  on(loadParameterDetails, (state) => ({
    ...state,
    isLoading: true,
    error: null as any, // type any because error interface is not defined in the provided code
  })),
  on(loadParametersSuccess, (state, { response, request }) => {
    return {
      ...state,
      isLoading: false,
      response: [...state.response, ...response],
      requested: [
        ...state.requested,
        ...request.filter(
          (r) =>
            !state.requested.some(
              (req) =>
                req.parameterCode === r.parameterCode &&
                req.parameterScopeTypeId === r.parameterScopeTypeId &&
                req.scopeId === r.scopeId,
            ),
        ),
      ],
    };
  }),
  on(loadParametersFailure, (state, { error, request }) => ({
    ...state,
    isLoading: false,
    error,
    requested: state.requested.filter(
      (req) =>
        !request.some(
          (r) =>
            r.parameterCode === req.parameterCode &&
            r.parameterScopeTypeId === req.parameterScopeTypeId &&
            r.scopeId === req.scopeId,
        ),
    ),
  })),
  on(refreshLoadParametersSuccess, (state, { response, request }) => {
    return {
      ...state,
      isLoading: false,
      response: response,
    };
  }),
);
